import { ExceptionService } from '../services/exception.service';
import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { TogetherDIPStage, TogetherDIPStageContainer } from './../models/app.models';
import { NodeAPIEntityService } from './../services/node.entity.service';
import { TogetherAuctionDIPEntityType } from './../models/enums';
import * as _ from 'lodash-es';
import moment from 'moment';
import numeral from 'numeral';
import { DipStateService } from '../services/dip-state-service.service';
import { NodeAPIService } from 'app/services/node.api.service';
import { Router } from '@angular/router';

@Component({
    selector: 'together-auction-dip-login-recap',
    templateUrl: './dip.login_recap.component.html',
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPLoginRecapComponent implements OnInit {

  @Input() stage: TogetherDIPStageContainer;
  @Input() incoming_case_id: string;
  @Output() stage_changing: EventEmitter<string> = new EventEmitter<string>();

  recap: object = {};
  _notifications: Array<object> = [];
  _isLoading: boolean = false;
  revisedRate: string;
  revisedRepayment: string;
  isSteppedProduct: boolean;

  selectedProduct: object = {};

  /**
   * Is this a DIP application (from state)
   *
   * @type {boolean}
   * @memberof TogetherAuctionDIPLoginRecapComponent
   */
  isDip: boolean;
  /**
   * Case ID (form state)
   *
   * @type {string}
   * @memberof TogetherAuctionDIPLoginRecapComponent
   */
  caseId: string;
  get Address() {
    const address = this.recap['Address'];
    if (_.isNil(address) === false) {
      const addressstr = `${_.defaultTo(address['HouseName'], '')}
        ${_.defaultTo(address['HouseNumber'], '')}
        ${_.defaultTo(address['Street1'], '')}
        ${_.defaultTo(address['Street2'], '')}
        ${_.defaultTo(address['PostTown'], '')}
        ${_.defaultTo(address['County'], '')}
        ${_.defaultTo(address['Postcode'], '')}`; // TODO: Need API from Manish / Harish

      if (!addressstr.trim()) {
        return 'Incomplete';
      }
      return addressstr;
    }
    return 'Incomplete';
  }

  get LoanAmount(): string {
    return '£' + numeral(this.recap['LoanAmount']).format('0,0');
  }

  get Payment(): string {
    return '£' + numeral(this.selectedProduct['InitialRepayment']).format('0.00');
  }

  get InterestRate(): string {
    return numeral(this.selectedProduct['InitialRate']).format('0.00') + '%';
  }

  get SubmittedDate() {
    if (_.isNil(this.recap['SubmissionDate'])) {
      return;
    }
    return moment(_.defaultTo(this.recap['SubmissionDate'], this.recap['ModifiedDate']))
      .format('DD/MM/YYYY HH:mm');
  }

  get IsSubmitted() {
    return !(_.isNil(this.recap['SubmissionReferrence'])
      || _.isEmpty(this.recap['SubmissionReferrence']));
  }

  get CaseReference() {
    return _.isNil(this.recap['CaseReference']) ? '' : 'Q' + this.recap['CaseReference'];
  }

  get IsExpired() {
    return (_.defaultTo(this.recap['IsDIPExpired'], false)) && this.isDip;
  }

  get IsCompleted() {
    return false;
  }

  get IsReferral() {
    return (this.recap['Outcome'] === 2) && this.isDip;
  }

  get IsRejected() {
    return (this.recap['Outcome'] === 3) && this.isDip;
  }

  get IsInProgress() {
    return this.recap['Outcome'] === 0;
  }

  get IsDipSuccess(): boolean {
    return (this.recap['Outcome'] === 1) && this.isDip;
  }

  get CanGenerateCert(): boolean {
    return this.IsDipSuccess && !this.IsExpired && !this.IsReferral && this.isDip;
  }

  get CanEditDip(): boolean {
    return !this.IsReferral && this.isDip && !this.IsSubmitted && this.IsInProgress;
  }

  get CanProceedToApp(): boolean {
    return (this.IsDipSuccess || this.IsInProgress) && !this.IsExpired
      && !this.IsReferral && !this.IsSubmitted;
  }

  get CanCopyCase(): boolean {
    return true;
  }

  /**
   * The text to be displayed about the status
   *
   * @readonly
   * @type {string}
   * @memberof TogetherAuctionDIPLoginRecapComponent
   */
  get StatusText(): string {
    if (this.IsSubmitted) {
      return 'Submitted';
    }
    if (this.IsExpired) {
      return 'Expired';
    }
    if (this.IsReferral) {
      return 'With Together';
    }
    if (this.IsInProgress) {
      return 'Incomplete';
    }
    if (this.IsRejected) {
      return 'Declined';
    }
    if (this.IsDipSuccess) {
      return 'Approved';
    }

  }

  get EditButtonText(): string {
    return this.isDip ? 'Pre-approval' : 'Loan Application';
  }

  get ForwardsText(): string {
    return this.isDip ? 'Progress my pre-approval' : 'Progress my application';
  }

  _clearErrors() {
    this._notifications = [];
  }

  _handleDeletedNotification(notification_iteration) {
    delete this._notifications[notification_iteration];
  }

  addNotification(title) {
    this._notifications.push({ text: title });
  }

  _handleError(error) {
    this._notifications.push({ text: error.error.message });
  }

  _handleEdit() {
    this.stage_changing.emit('tad_stage_edit');
  }

  _handleFullApplication() {
    this.stage_changing.emit('tad_stage_additional_loan_details');
  }

  handleCopyCase() {
    this._isLoading = true;
    var self = this;
    this.api.copyLoanDetails(this.caseId)
      .subscribe(
        (success) => {
          const data = JSON.parse(success['_body']);
          self.state.caseId.next(data['CaseId']);
          self.state.propertyType.next(data['PropertyType']);
          self.state.isDipJourney.next(data['IsDipJourney']);


          self._isLoading = false;

          self.router.navigate(['dip', 'tad_stage_loan_details',
            data['CaseId'],
            data['PropertyType'],
            data['IsDipJourney']]);
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this._isLoading = false;
        });
  }
  _handleShowCertificate() {
    const cert = this.entity.getDIPCertificate(this.incoming_case_id);
    window.open(cert, 'DIP Certificate', 'menubar=no,toolbar=no,scrollbars=no,resizable=yes,top=300,left=300,width=800,height=1000');
  }

  _handleDisableButtons() {
    return this._isLoading;
  }

  _handleForward() {
    if (this._isLoading === false) {
      this.stage_changing.emit(this.stage.current_stage.forward_reference);
    }
  }

  /**
   *
   *
   * @memberof TogetherAuctionDIPLoginRecapComponent
   */
  setProductData(product) {
    this.revisedRate = numeral(product['RevisedRate']).format('0.00') + '%';
    this.revisedRepayment = numeral(product['RevisedRepayment']).format('0.00');
    const plancode = product['PlanCode'];
    this.isSteppedProduct = _.isNil(plancode) ?
      false : plancode.indexOf('LR') >= 0;

  }


  _handleInitData(case_id) {
    this._isLoading = true;
    var self = this;
    this.entity.getAllEntities(TogetherAuctionDIPEntityType.Detail, case_id)
      .subscribe(
        (submit) => {
          self.recap = (submit as any);
          if (self.recap['Outcome'] === 1) {
            self.selectedProduct = _.filter(self.recap['Products'], (x) => {
              if (x['IsSelectedProduct'] === true) {
                return x;
              }
            })[0];
            self.setProductData(self.selectedProduct);
          }
          self.populateStateFromRecap(this.recap);
          self.setPageTitle();
          if (self.IsReferral) {
            self.state.overridePageTitle(`We're just checking a few things...`);
            self.state.overridePageSubTitle(
              `Our experienced team are reviewing the information you’ve provided.`);
          }
          self._isLoading = false;
        },
        (error) => {
          self.exception.haveReceivedError(error);
          self._isLoading = false;
        },
      );
  }

  setPageTitle() {
    let title = 'Your loan application';
    if (this.isDip) {
      title = 'Details of your pre-approved loan';

      if (this.IsReferral) {
        (`We're just checking a few things...`);
      }
      if (this.IsRejected) {
        title = `We can’t pre-approve your loan`;
      }

      if (this.IsExpired) {
        title = 'Your pre-approved loan offer has expired';
      }
    }
    if (this.IsInProgress) {
      title = `Welcome back`;
    }

    if (this.IsSubmitted) {
      title = 'Your loan application';
    }
    this.state.overridePageTitle(title);
  }
  populateStateFromRecap(recap: object): void {
    if (_.isNil(recap)) {
      this.stage_changing.emit('tad_stage_login');
      // *TODO* The below needs to be re-implemented once full state is sorted
      // } else if (recap['CaseId'] !== this.caseId) {
      // Validate the caseId against the one in the state
      // this.stage_changing.emit('tad_stage_login');
    } else {
      // populate state
      this.state.caseId.next(recap['CaseId']);
      this.state.isDipJourney.next(recap['IsDipJourney']);
      this.state.propertyType.next(_.toInteger(recap['PropertyType']));
    }
  }
  _handleInit() {
    // Is the entity not new? If so, let's get the details.
    if (this.entity.isNew(this.incoming_case_id) === false) {
      this._handleInitData(this.incoming_case_id);
    } else {
      // If we're not allowed to have a new reference, move.
      if (this.entity.allowNew(this.stage.current_stage.reference) === false) {
        this.stage_changing.emit('tad_stage_info');
      }
    }
  }

  ngOnInit() {
    this._handleInit();
  }


  constructor(private entity: NodeAPIEntityService,
    private router: Router,
    private state: DipStateService,
    private api: NodeAPIService,
    private exception: ExceptionService) {
    this.state.isDipJourney.subscribe((next) => {
      this.isDip = next;
    });
    this.state.caseId.subscribe((next) => {
      this.caseId = next;
    });
    this.isDip = this.state.isDipJourney.getValue();
    this.caseId = this.state.caseId.getValue();
    this.state.overridePageTitle('');
  }
}
